import { render, staticRenderFns } from "./Cesantia.vue?vue&type=template&id=1e679af8&scoped=true"
import script from "./Cesantia.vue?vue&type=script&lang=ts"
export * from "./Cesantia.vue?vue&type=script&lang=ts"
import style0 from "./Cesantia.vue?vue&type=style&index=0&id=1e679af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e679af8",
  null
  
)

export default component.exports